import { render, staticRenderFns } from "./r-range.vue?vue&type=template&id=2cb95339"
import script from "./r-range.vue?vue&type=script&lang=js"
export * from "./r-range.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb95339')) {
      api.createRecord('2cb95339', component.options)
    } else {
      api.reload('2cb95339', component.options)
    }
    module.hot.accept("./r-range.vue?vue&type=template&id=2cb95339", function () {
      api.rerender('2cb95339', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/utils/r-range.vue"
export default component.exports